export default "__VITE_ASSET__BY27P02x__"